let adminApiBaseUrl: string | null = null;

export function setAdminApiBaseUrl(url: string | null | undefined): void {
  const trimmed = url?.trim().replace(/\/$/, "") ?? "";
  adminApiBaseUrl = trimmed || null;
}

export function getAdminApiBaseUrl(): string | null {
  return adminApiBaseUrl;
}
